<template>
  <div class="applyManage">
    <template v-if="isApplyManage">
      <!-- 页面 title 标题 -->
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <!-- 基本信息导入功能 -->
      <ots-custom-dialog :dialog.sync="baseImportDialog" title="基本信息导入">
        <!-- 基本信息导入表单 -->
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="1.模板下载">
                <span style="color: #006aff" @click="excelTempCreateExt()" class="cp">
                  <i class="el-icon-download"></i>
                  下载基本信息导入数据模板
                </span>
              </el-form-item>
              <el-form-item v-model="importForm.Filedata">
                <ots-upload-file :httpRequest="handleFormData" fileType="xlsx"/>
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 基本信息导入按钮 -->
        <template v-slot:footer>
          <el-button round @click="baseImportDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">导入</el-button>
        </template>
      </ots-custom-dialog>
      <!-- 学生照片上传弹窗 -->
      <ots-custom-dialog :dialog.sync="upLoadImgDialog" title="照片上传">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form>
              <el-form-item label="请选择照片信息文件" v-model="upLoadImgForm.Filedata">
                <ots-upload-file ref="importImg" :httpRequest="handleImgFormData" fileType="zip"/>
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：只能上传扩展名为<span class="col_red">.zip</span>的文件；</div>
                <div>2：文件大小不能超过<span class="col_red">10M</span>；</div>
                <div>3：文件名不能是中文,<span class="col_red">照片以证件号命名；</span></div>
                <div>4：压缩包内只能是照片（不包含文件夹）；</div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="upLoadImgDialog = false">取消</el-button>
          <el-button round type="primary" @click="submitUploadImg">导入</el-button>
        </template>
      </ots-custom-dialog>
      <!-- 重置密码弹窗 -->
      <!-- <ots-custom-dialog :dialog.sync="repeatPsdDialog" title="重置密码" width="40%">
        <template v-slot:content>
          <div class="repeatPsd">
            确定将考生<span>{{ editPsdQuery.realName }}</span>的密码重置？重置后，密码为其<span>证件号后六位（不够六位前面补0）</span>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="repeatPsdDialog = false">取消</el-button>
          <el-button round type="primary" @click="submitRepeatPsd">确定</el-button>
        </template>
      </ots-custom-dialog> -->


    <!-- 重置密码 -->
    <ots-custom-dialog
      :dialog.sync="repeatPsdDialog"
      title="重置密码"
      width="480px"
    >
      <template v-slot:content>
        <div class="repass">
          <!-- <div class="name"> 
            <span class="name-username">用户名</span>
            <span>{{ rePassUserName }}</span>
          </div> -->
          <div class="name">
            <span class="name-realname">姓名：</span>
            <span>{{ rePassRealName }}</span>
          </div>
          <el-form :model="resetPass" ref="resetPass" :rules="passRule">
            <!-- 密码 -->
            <el-form-item label="新密码" prop="password">
              <el-input
                v-model="resetPass.password"
                autocomplete="new-password"
                placeholder="请输入新密码"
                type="password"
              ></el-input>
              <ots-password-tooltip></ots-password-tooltip>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input
                v-model="resetPass.confirmPassword"
                autocomplete="new-password"
                placeholder="请输入新密码"
                type="password"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="repeatPsdDialog = false">取消</el-button>
        <el-button round type="primary" @click="submitRepeatPsd('resetPass')">确定</el-button>
      </template>
    </ots-custom-dialog>

      <!-- 表格以及搜索 -->
      <ots-table-group-new
        :selectList="teaSelectList"
        :requestForm="requestForm"
        @search="search"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
        :pagination="pagination"
        @changeCity="changeCityFN"
        @changeNum="changeNum"
        @changePage="changePage"
      >
      </ots-table-group-new>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import {Export,Excel,Import,ImportPhoto,DeleteUser,unfreezeAccountAPI} from '@/http/modules/applySet/studentManage';
import { checkPwd, passWordStrength } from "@/common/verify.js";

export default {
  data() {
    return {
      endTime: "",
      mainTopBtnList: [
        {
          title: "批量导入",
          select: true,
          plain: true,
          children: [
            { title: "基本信息导入", fn: this.baseImport },
            { title: "学生照片导入", fn: this.phoneImport },
          ],
        },
        {
          title: "导出",
          plain: true,
          fn: this.exportStu,
        },
        {
          title: "新增",
          fn: this.addUser,
        },
      ],
      baseImportDialog: false,
      importForm: {
        file: "",
      },
      upLoadImgDialog: false,
      repeatPsdDialog: false,
      editPsdQuery: {
        realName: "",
        userId: "",
        password: "",
        confirmPassword: "",
      },
      upLoadImgForm: {
        Filedata: "",
      },
      requestForm: {
        searchKey:'',
        phone: "",
        email: "",
        applyState: "",
        schoolId: "",
        stationId: "",
        cardType: '',
        page: 1,
        size: 10,
      },
      passRule: {
        password: [
          { required: true, message: "请输入设置密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
      teaSelectList: [
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
        {
          title: "证件类型",
          type: "select",
          requestKey: "cardType",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "身份证" },
            { id: 2, name: "护照" },
            { id: 3, name: "士官证" },
            { id: 4, name: "港澳台身份证" },
          ]
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
        {
          title: "邮箱",
          type: "input",
          requestKey: "email",
          placeholder: "请输入",
        },
        {
          title: "报名状态",
          type: "select",
          requestKey: "applyState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "是" },
            { id: 0, name: "否" }
          ]
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
          ],
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
          ],
        },
      ],

      tableHeader: [
        {
          title: "姓名",
          width: "80",
          prop: "realName",
          fixed: "left",
        },
        {
          title: "性别",
          width: "60",
          prop: "sex",
        },
        {
          title: "证件类型",
          width: "120",
          prop: "cardType"
        },
        {
          title: "证件号",
          width: "200",
          prop: "cardNo",
        },
        {
          title: "手机号",
          width: "115",
          prop: "phone",
        },
        {
          title: "邮箱",
          width: "160",
          prop: "email",
        },
        {
          title: "院校",
          width: "200",
          prop: "school",
        },
        {
          title: "教学点",
          prop: "station",
          width: "200",
        },
        {
          title: "基础照片",
          type: "img",
          prop: "photo",
          fixed: "right",
        },
        {
          title: "报名状态",
          prop: "applyState",
          fixed: "right",
          width: "120"
        },
        {
          title: "操作",
          type: "buttons",
          width: "240",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          btnList: [
            {
              title: "重置密码",
              click: this.repeatPsd,
            },
            {
              title: "解冻",
              click: this.thawing,
            },
            {
              title: "编辑",
              click: this.edit,
            },
            {
              title: "删除",
              click: this.delet,
            },
            
          ],
        },
      ],
      tableData: [],
      batchOperBtn: [],
      pagination: {
        total: 0,
      },
      needAudit: "",
      roleType: "",
      customSearch: [],
      isSetStateName: "",
      optionalSession: '',

      resetPass: {
        password: "",
        confirmPassword: "",
        userId: "",
        tenant: "",
      },
      rePassUserName: '',
      rePassRealName: '',
    };
  },
  computed: {
    isApplyManage() {
      return this.$route.name === "studentManageMent"
    },
  },
  watch: {
    $route: {
      handler: function(route) {
        if (route.name == "studentManageMent") {
          this.getTableList()
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 密码解冻
    async thawing(row) {
      const { code } = await unfreezeAccountAPI({userId: row.stuId});
      if (code == 1) {
        this.$message.success(`学生 ${row.realName} 已解除冻结状态！`);
      }
    },

    // 重置密码表单失焦事件
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.resetPass.password !== this.resetPass.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback();
        }
      }
      callback();
    },

    /*******************************************
     * @getData 自定义 + 搜索表单 数据配置
     *******************************************/
    getData() {
      const typeList = ['select', 'province', 'subject', 'nation', 'politicalStatus', 'level']
      this.mixin_setUserExtInfo().then((res) => {
        res.data.map((item) => {
          if (item.queryCondition == 1) {
            if ( typeList.includes(item.type) ) {
              if (item.valueVo) {
                let search = {
                  title: item.displayName,
                  type: "select",
                  requestKey: item.name,
                  label: "name",
                  value: "name",
                  data: [ { name: "全部" }, ...item.valueVo ],
                }
                this.customSearch.push(search)
              }
            } else if (item.type == "text") {
              let search = {
                title: item.displayName,
                type: "input",
                requestKey: item.name,
                placeholder: "请输入",
              }
              this.customSearch.push(search)
            } else if (item.type == "provinceCity") {
              let search = {
                title: item.displayName,
                type: "cascader",
                requestKey: item.name,
                label: "name",
                value: "name",
                data: [ { name: "全部" }, ...item.valueVo ],
              }
              this.customSearch.push(search)
            }
          }
          if (item.type == "imageUpload") {
            let tables = {
              title: item.displayName,
              type: "img",
              width: "120",
              prop: item.name,
            }
            this.tableHeader.push(tables)
          } else {
            let tables = {
              title: item.displayName,
              width: "120",
              prop: item.name,
            }
            this.tableHeader.push(tables)
          }
        })
        this.requestForm = Object.assign(this.requestForm, res.requestForm)
        this.teaSelectList = [...this.teaSelectList, ...this.customSearch]
      })
      this.mixin_getSelectSchool().then((data) => {
        let newSchoolList = [{ id: "", name: "全部" }, ...data]
        this.$set(this.teaSelectList[5], "data", newSchoolList)
      })
      this.mixin_getSelectStation().then((data) => {
        let newStationList = [{ id: "", name: "全部" }, ...data]
        this.$set(this.teaSelectList[6], "data", newStationList)
      })
    },

    /*******************************************
     * @excelTempCreateExt 基本信息模板下载
     *******************************************/    
    excelTempCreateExt() {
      Excel().then(res => {
        window.location.href = res.data
      })
    },

    /*******************************************
     * @baseImport 基本信息弹窗,上传参数
     *******************************************/
    baseImport() {
      this.importForm.limitRegionState = 1
      this.importForm.preRegistrationState = 1
      this.baseImportDialog = true
    },

    /*******************************************
     * @handleFormData 基本信息文件处理
     *******************************************/
    handleFormData(val) {
      this.importForm.file = val.file
    },

    /*******************************************
     * @rightImport 基本信息导入Import
     *******************************************/
    rightImport() {
      if (!this.importForm.file) {
        this.$message.error("请选择文件")
        return
      }
      const fd = new FormData()
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item])
      }
      Import(fd).then((res) => {
        if (res.code) {
          this.baseImportDialog = false
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0
          const totalNum = parseInt(res.data.allCount)
          const successNum = totalNum - failNum
          let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address
            }
          })
          this.getTableList()
        }
      });
    },

    /*******************************************
     * @phoneImport '照片导入'弹窗开启
     *******************************************/
    phoneImport() {
      this.upLoadImgDialog = true
    },

    /*******************************************
     * @handleImgFormData "照片导入"文件处理
     *******************************************/
    handleImgFormData(val) {
      this.upLoadImgForm.Filedata = val.file
    },

    /*******************************************
     * @submitUploadImg 学生照片导入
     *******************************************/
    submitUploadImg() {
      if (!this.upLoadImgForm.Filedata) {
        this.$message.error("请选择文件")
        return
      }
      const fd = new FormData()
      let param = {
        file: this.upLoadImgForm.Filedata,
      }
      for (let item in param) {
        fd.append(item, param[item])
      }
      ImportPhoto(fd).then(res=>{
        if (res.code) {
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0
          const totalNum = parseInt(res.data.allCount)
          const successNum = totalNum - failNum
          let message = `导入完成，成功导入照片${successNum}张，导入失败${failNum}张`
          this.upLoadImgDialog = false
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address
            }
          })
          this.getTableList()
        }
      });
    },

    /*******************************************
     * @addUser 添加报名学生
     *******************************************/
    addUser() {
      let stationIdName =  this.teaSelectList[6].data.filter((item)=>item.id === this.requestForm.stationId)
      let SchoolListName =  this.teaSelectList[5].data.filter((item)=>item.id === this.requestForm.schoolId)
      let stationName = stationIdName[0].name
      let SchoolName = SchoolListName[0].name
      this.$router.push({
        path: "studentManageMent/studentManageMentAdd",
        query:{
          stationName:stationName,
          SchoolName:SchoolName
        }
      })
    },

    /*******************************************
     * @getTableList 获取表格信息
     *******************************************/
    getTableList() {
      for (let key in this.requestForm) {
        if (this.requestForm[key] == "全部") {
          this.requestForm[key] = ""
        }
      }
      let params = { ...this.requestForm }
      this.$api.applyManage.selectRegisterUserList(params).then(res=>{
        if (res.code == 1) {
          this.tableData = res.data.records
          this.pagination.total = res.data.total
          res.data.records.forEach((e) => {
            e.extData.forEach((item) => {
              e[item.name] = item.value
            })
          })
        }
      })
    },

    // 重置密码
    // 2024年7月23日 ==> 需求修改为取消手动输入，设置为默认后六位。（后端修改）
    async repeatPsd(val) {
      let { realName } = val;
      let msg = `重置 ${realName} 的密码？（新密码为证件号后 6 位）`;
      this.$confirm(msg, "重置密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          userId: val.stuId,
          tenant: window.localStorage.getItem("tenant"),
          setDefault: 1,
          password: '',
          confirmPassword: '',
        }
        const { code } = await this.$api.login.editPsd(params);
        if (code == 1) {
          this.$message.success("重置密码，操作成功！");
        }
      });
    },


    // /*******************************************
    //  * @repeatPsd 重置密码(根据证件号配置密码,参数)
    //  *******************************************/
    // repeatPsd(val) {
    //   this.resetPass.password = "";
    //   this.resetPass.confirmPassword = "";
    //   this.resetPass.userId = val.stuId;
    //   this.resetPass.tenant = window.localStorage.getItem("tenant"),
    //   // this.rePassUserName = val.userName;
    //   this.rePassRealName = val.realName;
    //   this.repeatPsdDialog = true;

    //   return;
    //   this.repeatPsdDialog = true
    //   let stuid = val.stuId
    //   let cardNo = val.cardNo
    //   let resetPassword = ""
    //   let hanzi = new RegExp("[\u4e00-\u9fa5]")
    //   if (hanzi.test(cardNo)) {
    //     resetPassword = "000000"
    //   } else if (cardNo.length >= 6) {
    //     resetPassword = cardNo.substring(cardNo.length - 6)
    //   } else {
    //     let zeroNum = 6 - cardNo.length
    //     for (let i = 0; i < zeroNum; i++) { resetPassword = resetPassword + "0" }
    //     resetPassword = resetPassword + cardNo
    //   }
    //   this.editPsdQuery = {
    //     userId: stuid,
    //     password: resetPassword,
    //     confirmPassword: resetPassword,
    //     tenant: window.localStorage.getItem("tenant"),
    //   }
    // },

    // 执行"重置密码"
    submitRepeatPsd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {...this.resetPass}
          this.$api.login.editPsd(params).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功！");
              this.repeatPsdDialog = false;
            }
          });
        } else {
          console.log("Error Submit");
          return false;
        }
      });
    },

    /*******************************************
     * @edit 跳转"编辑"
     *******************************************/
    edit(val) {
     let stationIdName =  this.teaSelectList[6].data.filter((item)=>item.id === this.requestForm.stationId)
     let SchoolListName =  this.teaSelectList[5].data.filter((item)=>item.id === this.requestForm.schoolId)
     let stationName = stationIdName[0].name
     let SchoolName = SchoolListName[0].name
     val.stationName = stationName
     val.SchoolName = SchoolName 
      this.$router.push({
        path: "/studentManageMent/studentManageMentAdd",
        query:val
      })
    },

    /*******************************************
     * @delet 删除
     *******************************************/
    delet(val) {
      let stuId = val.stuId
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        DeleteUser({stuId}).then((res) => {
          if (res.code) {
            this.$message.success("删除成功！")
            this.getTableList()
          }
        })
      })
    },

    /*******************************************
     * @exportStu 导出
     *******************************************/
    exportStu() {
      let { page, size, ...queryFrom } = this.requestForm
      Export(queryFrom).then(res=>{
        if (res.code == 1) {
          window.open(res.data)
        }
      })
    },

    /*******************************************
     * @search "查询"按钮
     *******************************************/
    search() {
      this.requestForm.page = 1
      this.getTableList()
    },

    /*******************************************
     * @planSearch "切换批次"查询
     *******************************************/
    planSearch() {
      this.requestForm.page = 1
      this.requestForm.stateType = ""
      this.getTableList()
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableList()
    },

    changePage(p) {
      this.requestForm.page = p
      this.getTableList()
    },

    changeCityFN(e, attr) {
      this.requestForm[attr] = e.toString()
    },

  },

};
</script>

<style lang="less" scoped>
.repass {
  .name {
    width: 50%;
    display: inline-block;
    padding-left: 4px;
    box-sizing: border-box;
    margin-bottom: 32px;

    .name-username,
    .name-realname {
      color: #737780;
      font-size: 14px;
      font-weight: 400;
      display: inline-block;
      margin-right: 16px;
    }

    .name-username + span,
    .name-realname + span {
      color: #45494d;
    }
  }

  .el-form {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .el-form-item {
      width: 408px;

      /deep/ .el-form-item__label {
        color: #737780;
      }
    }

    /deep/ .el-input__inner {
      width: 408px;
    }

    .checkUser {
      width: 100%;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 19px 0 0 16px;
      margin-bottom: 22px;

      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;

        .el-checkbox {
          margin-right: 0;
          margin-bottom: 12px;
          width: 50%;
        }
      }
    }
  }
}
.applyManage {
  .el-alert {
    margin-bottom: 24px;
    background: #fff5e0;
    border: 1px solid #ff9500;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    .importantNote {
      font-size: 14px;
      color: #ff9500;
      margin-left: -10px;
      margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #ff9500;
    }
  }
  /deep/ .unDistributed {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #fe5958;
      border-radius: 50%;
    }
  }
  /deep/ .unFinish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #006aff;
      border-radius: 50%;
    }
  }
  /deep/ .wait {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #f27900;
      border-radius: 50%;
    }
  }
  /deep/ .finish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #1dbf60;
      border-radius: 50%;
    }
  }
}
.exportDialog {
  .impExplain {
    margin-top: 32px;
    color: #9299a6;
    // display: flex;
    .tipTitle {
      flex-shrink: 0;
      display: block;
      margin-bottom: 12px;
    }
    div {
      line-height: 1.8;
    }
  }
}
.downTemplate {
  display: block;
  padding: 8px 0 0px 0;
  color: #3388ff;
  font-size: 13px;
  text-decoration: none;
}
.repeatPsd {
  font-size: 14px;
  color: #45494d;
  span {
    color: #2d2f33;
    font-weight: 600;
  }
}
</style>